// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"4deb96a2","440":"0ceae93e","477":"8de9b4c9","488":"fbd579a2","841":"1c84b3da"}[chunkId] + ".chunk.js";
};